
<template>
  <iframe id="photopea" src="https://www.photopea.com/" />
</template>


<script>
import Vue from "vue";
import firebase from "firebase";
require("firebase/firestore");

export default {
  name: "modal",
  props: ["image"],
  components: {
    
  },
  watch: {
    initialised: function(val) {
      if(val && this.dataForInitialised) {
        console.log("SENDING DATA");
        this.photopeaWnd.postMessage(this.dataForInitialised, "*");
      }
    }
  },
  data: function() {
    return {
      openStockImage: false,
      photopeaWnd: null,
      messageCount: 0,
      initialised: false,
      dataForInitialised: false,
      saveAs: "data"
    };
  },
  mounted: function() {
    window.scrollTo(0,0);
    document.body.style.overflowY = "hidden";
    this.photopeaWnd = document.getElementById("photopea").contentWindow;
    window.addEventListener("message", this.ppReady);
  },
  beforeDestroy() {
    document.body.style.overflowY = "scroll";
  },
  methods: {
    ppReady: function(msg) {
      this.messageCount++;
      if(this.messageCount==2) {
        this.initialised = true;
      }
      if(typeof msg.data == "object") {
        if(this.saveAs == "url") {
          firebase.storage().ref()
            .child("cms_images").child((Date.now() / 1000) + "_edited.jpg")
            .put(msg.data)
            .then(async (snapshot) => {
            
            var url = await snapshot.ref.getDownloadURL();
            console.log('Uploaded array data!', url);
          // this.froalaEditor.image.insert(url, null, null, editor.image.get());
            this.$emit('save-url', {url: url});
          });
        } else {
          this.$emit('save-data', {nextStep: 'third', bytes: msg.data});
        }

      }
      console.log(typeof msg.data);
    },
    openImageUrl: function(url) {
      console.log(`app.open("${url}", 0, 1)`);
      if(this.initialised) this.photopeaWnd.postMessage(`app.open("${url}", 0, 1)`, "*");
      else this.dataForInitialised = `app.open("${url}", 0, 1)`;
    },
    openImageData: function(data) {
      if(this.initialised) this.photopeaWnd.postMessage(data, "*");
      else this.dataForInitialised = data;
    },
    saveImageData: function() {
      this.saveAs = "data";
      this.photopeaWnd.postMessage("activeDocument.saveToOE(\"jpg\")","*");
    },
    saveImageUrl: function() {
      this.saveAs = "url";
      this.photopeaWnd.postMessage("activeDocument.saveToOE(\"jpg\")","*");
    }
  }
};
</script>

<style scoped>
iframe {
  width: 100%;
  height: calc(98vh - 75px);
  margin: 0 auto;
  display: block;
}
</style>


// WEBPACK FOOTER //
// imageEdit.vue?8eb97168